import { InferValueTypes } from '~/src/store';

import * as actionCreators from './actions';

export const actionTypes = {
    INITIALIZED: '@LK/BALANCE_HYSTORY/INITIALIZED',
    CLEAR_DATA: '@LK/BALANCE_HYSTORY/CLEAR_DATA',
    SET_HISTORY: '@LK/BALANCE_HYSTORY/SET_HISTORY',
    SET_HISTORY_LOADING: '@LK/BALANCE_HYSTORY/SET_HISTORY_LOADING',
    SET_HISTORY_ERROR: '@LK/BALANCE_HYSTORY/SET_HISTORY_ERROR',
    SET_CURRENT_PERIOD: '@LK/BALANCE_HYSTORY/SET_CURRENT_PERIOD',
    ADD_PERIODS: '@LK/BALANCE_HYSTORY/ADD_PERIODS',
    SET_PERIOD_LOADING: '@LK/BALANCE_HYSTORY/SET_PERIOD_LOADING',
    SET_PERIOD_ERROR: '@LK/BALANCE_HYSTORY/SET_PERIOD_ERROR',
    SET_ALL_PERIODS_FETCHED: '@LK/BALANCE_HYSTORY/SET_ALL_PERIODS_FETCHED',
} as const;

import { ELoadingStatus, IBalanceHistoryState, initHistory, initialState } from './initialState';

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;
export type { IBalanceHistoryState } from './initialState';

export const balanceHistory = (state: IBalanceHistoryState = initialState, action: TActions): IBalanceHistoryState => {
    switch (action.type) {
        case actionTypes.INITIALIZED: {
            return {
                ...action.payload,
                isPeriodsLoading: false,
                periodError: '',
            };
        }
        case actionTypes.SET_HISTORY_LOADING: {
            const currentHistory = state.historyByPeriod[action.payload] || initHistory;

            return {
                ...state,
                historyByPeriod: {
                    ...state.historyByPeriod,
                    [action.payload]: {
                        ...currentHistory,
                        loadingStatus: ELoadingStatus.loading,
                    },
                },
            };
        }
        case actionTypes.SET_HISTORY: {
            return {
                ...state,
                historyByPeriod: {
                    ...state.historyByPeriod,
                    [action.payload.period]: {
                        ...action.payload.data,
                        loadingStatus: ELoadingStatus.success,
                        errorMsg: '',
                    },
                },
            };
        }
        case actionTypes.SET_HISTORY_ERROR: {
            const currentHistory = state.historyByPeriod[action.payload.period] || initHistory;

            return {
                ...state,
                historyByPeriod: {
                    ...state.historyByPeriod,
                    [action.payload.period]: {
                        ...currentHistory,
                        loadingStatus: ELoadingStatus.error,
                        errorMsg: action.payload.error,
                    },
                },
            };
        }
        case actionTypes.SET_PERIOD_LOADING: {
            return {
                ...state,
                isPeriodsLoading: true,
            };
        }
        case actionTypes.SET_CURRENT_PERIOD: {
            return {
                ...state,
                currentPeriod: action.payload,
            };
        }
        case actionTypes.ADD_PERIODS: {
            return {
                ...state,
                periods: [...state.periods, ...action.payload],
                isPeriodsLoading: false,
            };
        }
        case actionTypes.SET_ALL_PERIODS_FETCHED: {
            return {
                ...state,
                isAllPeriodsFetched: true,
            };
        }
        case actionTypes.SET_PERIOD_ERROR: {
            return {
                ...state,
                periodError: action.payload,
                isPeriodsLoading: false,
            };
        }
        case actionTypes.CLEAR_DATA: {
            return initialState;
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};
